export const ModuleName = 'pdl';
export const DisplayName = 'Datarättigheter';
